module.exports = __webpack_public_path__ + "static/00024.5a606173.jpg";